// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerGroupQueryPerformanceQueryVariables = Types.Exact<{
  serverGroupId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type ServerGroupQueryPerformanceQuery = {
  __typename?: "GraphqlQuery";
  getQueryOverviewStatsByDatabaseGroup?: Array<{
    __typename?: "QueryOverviewStatsByDatabaseGroupResult";
    id: string;
    avgTime?: number | null;
    pctOfTotalIo?: number | null;
    pctOfTotal?: number | null;
    queriesPerSecond?: number | null;
    queriesPerSecondSeries?: Array<Array<number | null> | null> | null;
    databaseGroup?: {
      __typename?: "DatabaseGroup";
      id: string;
      datname: string;
      hidden: boolean;
    } | null;
  }> | null;
};

export const ServerGroupQueryPerformanceDocument = gql`
  query ServerGroupQueryPerformance(
    $serverGroupId: ID!
    $startTs: Int!
    $endTs: Int!
  ) {
    getQueryOverviewStatsByDatabaseGroup(
      serverGroupId: $serverGroupId
      startTs: $startTs
      endTs: $endTs
    ) {
      id
      databaseGroup {
        id
        datname
        hidden
      }
      avgTime
      pctOfTotalIo
      pctOfTotal
      queriesPerSecond
      queriesPerSecondSeries
    }
  }
`;

/**
 * __useServerGroupQueryPerformanceQuery__
 *
 * To run a query within a React component, call `useServerGroupQueryPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerGroupQueryPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerGroupQueryPerformanceQuery({
 *   variables: {
 *      serverGroupId: // value for 'serverGroupId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useServerGroupQueryPerformanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  > &
    (
      | { variables: ServerGroupQueryPerformanceQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  >(ServerGroupQueryPerformanceDocument, options);
}
export function useServerGroupQueryPerformanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  >(ServerGroupQueryPerformanceDocument, options);
}
// @ts-ignore
export function useServerGroupQueryPerformanceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupQueryPerformanceQuery,
  ServerGroupQueryPerformanceQueryVariables
>;
export function useServerGroupQueryPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupQueryPerformanceQuery,
        ServerGroupQueryPerformanceQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerGroupQueryPerformanceQuery | undefined,
  ServerGroupQueryPerformanceQueryVariables
>;
export function useServerGroupQueryPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerGroupQueryPerformanceQuery,
        ServerGroupQueryPerformanceQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerGroupQueryPerformanceQuery,
    ServerGroupQueryPerformanceQueryVariables
  >(ServerGroupQueryPerformanceDocument, options);
}
export type ServerGroupQueryPerformanceQueryHookResult = ReturnType<
  typeof useServerGroupQueryPerformanceQuery
>;
export type ServerGroupQueryPerformanceLazyQueryHookResult = ReturnType<
  typeof useServerGroupQueryPerformanceLazyQuery
>;
export type ServerGroupQueryPerformanceSuspenseQueryHookResult = ReturnType<
  typeof useServerGroupQueryPerformanceSuspenseQuery
>;
export type ServerGroupQueryPerformanceQueryResult = Apollo.QueryResult<
  ServerGroupQueryPerformanceQuery,
  ServerGroupQueryPerformanceQueryVariables
>;
